module.exports = __webpack_public_path__ + "static/fighter-03-05bd6f7acfd09f7e6acad8d46ce8055e.png";